module.exports = __webpack_public_path__ + "img/xiuzheng_grey.cffa8579.svg";